export enum Countries {
     NA = 0,
     USA = 1,
     Canada = 2,
     Mexico = 3
}
